import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'users-tab-summary',
  templateUrl: './users-tab-summary.component.html',
  styleUrls: ['./users-tab-summary.component.scss']
})
export class UsersTabSummaryComponent implements OnInit {

  selectedCount;
  userDetails;
  @Input() userGroupIdToName;
  @Input() set selection(selection) {
    this.userDetails = {};
    this.selectedCount = selection.length;

    if (selection.length === 1) {
      this.extractUserDetails(selection[0]);
    }
  }
  constructor() { }

  ngOnInit(): void {
  }

  private extractUserDetails(user): void {
    this.userDetails.name = user.name;
    this.userDetails.origin = user.origin;
    this.userDetails.groups = [];
    user.groups.forEach(groupId => {
      this.userDetails.groups.push(this.userGroupIdToName[groupId]);
    });

    this.extractDictionaryAttributes(user);
  }

  private extractDictionaryAttributes(user): void {
    this.userDetails.dicAttributes = [];

    if (user.dicAttributes) {
      user.dicAttributes.forEach((attribute) => {
        const attr = this.userDetails.dicAttributes.find((dicAttribute) => {
          return dicAttribute.name === attribute.dicAttrName;
        });
        if (attr) {
          attr.value.push(attribute.value);
        } else {
          this.userDetails.dicAttributes.push({
            name: attribute.dicAttrName,
            value: [ attribute.value ]
          });
        }
      });
    }
  }
}
